module.exports = __webpack_public_path__ + "static/media/members-icon.a64da1bf.svg";